import { SvgPath } from "../types/svg-types"

export const TO_BUILD_LOGO_SVG_PATHS: SvgPath[] = [
    {   // T
        path: 'm 0,0 v 5.408 h -7.419 v 20.505 h -5.409 v -20.505 h -7.42 V 0 Z',
        // translation: { x: 109.7305, y: 68.8692 },
        translation: { x: 20.505, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // O
        path: 'M 0,0 C -0.036,4.35 10.49, 4.312 10.49,0 V -9.723 C 10.526,-14.182 0,-14.071 0,-9.723 Z M 15.863,-9.723 V 0 c 0,11.477 -21.199,11.514 -21.199,0 v -9.723 c 0,-11.549 21.199,-11.475 21.199,0',
        // translation: { x: 117.5508, y: 51.0333 },
        translation: { x: 28.3253, y: -17.8359 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // B
        path: 'm 0,0 h 4.86 c 5.044,0 5.118,-5.921 0,-5.921 H 2.389 v -4.605 H 4.86 c 3.656,0 4.094,-4.899 0,-4.899 H 0 Z M 10.526,-8.553 C 13.742,-6.981 14.363,-3.947 13.998,-1.354 13.522,2.119 11.001,5.227 5.044,5.227 H -5.373 V -20.687 H 4.86 c 4.46,0 8.115,2.594 8.115,7.602 0,1.462 -0.695,3.545 -2.449,4.532',
        // translation: { x: 152.166, y: 48.1827 },
        translation: { x: 62.9405, y: -20.6865 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // U
        path: 'm 0,0 v 17.396 c 0,4.862 9.503,4.825 9.503,0 V 0 h 5.41 v 17.396 c -0.037,11.805 -20.322,11.842 -20.322,0 l 0,-17.396 z',
        // translation: { x: 176.0137, y: 68.8321 },
        translation: { x: 86.7882, y: -0.0371 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // I
        path: 'm 196.743,-68.832 h 5.373 V -42.956 h -5.373 z',
        translation: { x: -89.2255, y: -68.8692 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // L
        path: 'm 0,0 h -16.558 v -25.876 h 5.374 V -5.409 L 0,-5.409 Z',
        // translation: { x: 224.293, y: 42.9561 },
        translation: { x: 135.0675, y: -25.9131 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    },
    {   // D
        path: 'm 0,0 c 2.339,0 4.458,-0.769 4.458,-2.852 v -9.211 c 0,-2.119 -2.119,-2.996 -4.458,-2.996 H -4.131 V 0 Z M -9.503,5.409 V -20.467 H 0 c 5.116,0 9.868,2.557 9.868,8.404 V -2.852 C 9.868,2.959 5.116,5.409 0,5.409 Z',
        // translation: { x: 238.291, y: 48.3653 },
        translation: { x: 149.0655, y: -20.5039 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b
    }
]

export const TO_BUILD_PAYOFF_SVG_PATHS: SvgPath[] = [
    {   // Bar
        path: 'm 74.609,1.294 l 3.565,0.000 L 78.175,65.934 L 74.609,65.934 L 74.609,1.294',
        translation: { x: 0, y: 0 },
        fillColor: 0x231f20,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // Circle
        path: 'M 0.000,33.475 C 0.000,14.989 14.987,0.004 33.479,0.004 51.966,0.004 66.956,14.989 66.956,33.475 66.956,51.962 51.966,66.947 33.479,66.947 14.987,66.947 0.000,51.962 0.000,33.475',
        // translation: { x: 109.7305, y: 68.8692 },
        translation: { x: 0, y: 0 },
        fillColor: 0x231f20,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // B
        path: 'm 28.799,46.055 l 7.523,0.000 c 7.807,0.000 7.924,-9.165 0.000,-9.165l -3.828,0.000 l 0.000,-7.128 l 3.828,0.000 c 5.659,0.000 6.339,-7.580 0.000,-7.580l -7.523,0.000 z m 16.305,-13.883 c 4.979,2.432 5.940,7.128 5.375,11.149 -0.737,5.372 -4.643,10.183 -13.865,10.183L 20.487,53.503 L 20.487,13.388 L 36.331,13.388 c 6.904,0.000 12.563,4.018 12.563,11.770 0.000,2.263 -1.073,5.490 -3.789,7.014',
        translation: { x: 0, y: 0 },
        fillColor: 0xffffff,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // O
        path: 'm 86.448,36.888 c 0.000,1.694 1.727,2.534 3.466,2.534 1.742,0.000 3.466,-0.839 3.482,-2.534l 0.000,-4.711 c 0.000,-1.787 -1.755,-2.535 -3.497,-2.535 -1.724,0.013 -3.451,0.778 -3.451,2.535z m -0.586,-4.711 c 0.000,-2.073 2.026,-3.109 4.052,-3.109 2.026,0.000 4.068,1.037 4.068,3.109l 0.000,4.711 c 0.000,2.071 -2.042,3.120 -4.068,3.120 -2.026,0.000 -4.052,-1.049 -4.052,-3.120l 0.000,-4.711',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // U
        path: 'm 96.336,29.221 l 0.586,0.000 l 0.000,7.560 c 0.000,1.727 1.617,2.567 3.240,2.567 1.622,0.000 3.258,-0.841 3.258,-2.567l 0.000,-7.560 l 0.586,0.000 l 0.000,7.560 c 0.000,2.100 -1.925,3.172 -3.844,3.172 -1.922,0.000 -3.825,-1.072 -3.825,-3.172l 0.000,-7.560',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // T
        path: 'm 105.607,29.203 l 7.667,0.000 l 0.000,0.589 l -3.539,0.000 l 0.000,10.036 l -0.586,0.000 l 0.000,-10.036 l -3.542,0.000 l 0.000,-0.589',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // S
        path: 'm 118.107,34.140 c 1.786,0.359 3.721,0.946 3.602,3.122 -0.073,1.787 -1.859,2.714 -3.646,2.714 -1.411,0.000 -3.003,-0.615 -3.630,-1.841l 0.523,-0.242 c 0.539,0.989 1.875,1.529 3.135,1.529 1.424,0.000 2.836,-0.628 3.031,-2.172 0.120,-1.849 -1.575,-2.252 -3.180,-2.599 -1.635,-0.344 -3.482,-1.005 -3.393,-3.000 0.063,-1.741 1.773,-2.583 3.529,-2.583 1.453,0.000 2.940,0.587 3.557,1.787 -0.229,0.107 -0.333,0.135 -0.526,0.228 -0.510,-0.978 -1.831,-1.487 -3.031,-1.487 -1.456,0.000 -2.852,0.540 -2.958,2.070 -0.120,1.500 1.320,2.147 2.987,2.475',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // T
        path: 'm 122.802,29.203 l 7.669,0.000 l 0.000,0.589 l -3.542,0.000 l 0.000,10.036 l -0.586,0.000 l 0.000,-10.036 l -3.542,0.000 l 0.000,-0.589',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // A
        path: 'm 136.141,35.567 -2.175,-6.122 -2.178,6.122 z m -2.597,-6.557 l 0.857,0.000 l 3.901,10.835 l -0.631,0.000 l -1.336,-3.692 l -4.755,0.000 c -0.391,1.139 -0.901,2.550 -1.292,3.692l -0.630,0.000 l 3.885,-10.835',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // N
        path: 'm 139.981,29.221 l 0.735,0.000 l 6.153,9.888 l 0.000,-9.888 l 0.584,0.000 l 0.000,10.624 l -0.855,0.000 l -6.033,-9.725 l 0.000,9.725 l -0.584,0.000 l 0.000,-10.624',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // D
        path: 'm 150.904,39.260 l 3.104,0.000 c 1.623,0.000 2.945,-0.678 2.945,-2.355l 0.000,-4.728 c 0.000,-1.696 -1.323,-2.372 -2.945,-2.372l -3.104,0.000 z m -0.587,0.585 l 0.000,-10.624 l 3.691,0.000 c 1.921,0.000 3.528,0.867 3.528,2.956l 0.000,4.728 c 0.000,2.070 -1.607,2.940 -3.528,2.940l -3.691,0.000',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // I
        path: 'm 159.639,29.234 l 0.585,0.000 l 0.000,10.611 l -0.585,0.000 l 0.000,-10.611',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // N
        path: 'm 163.101,29.221 l 0.737,0.000 l 6.151,9.888 l 0.000,-9.888 l 0.587,0.000 l 0.000,10.624 l -0.857,0.000 l -6.031,-9.725 l 0.000,9.725 l -0.587,0.000 l 0.000,-10.624',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    },
    {   // G
        path: 'm 172.917,32.190 c 0.000,-2.025 1.919,-3.075 3.825,-3.075 1.411,0.000 2.804,0.540 3.419,1.696 -0.211,0.103 -0.328,0.178 -0.525,0.271 -0.521,-0.962 -1.724,-1.382 -2.925,-1.382 -1.607,0.000 -3.211,0.827 -3.211,2.490l 0.000,4.638 c 0.000,1.695 1.620,2.521 3.243,2.521 1.620,0.000 3.255,-0.826 3.255,-2.521l 0.000,-1.577 l -3.255,0.000 l 0.000,-0.583 l 3.841,0.000 l 0.000,2.160 c 0.000,2.088 -1.923,3.126 -3.841,3.126 -1.923,0.000 -3.825,-1.038 -3.825,-3.126l 0.000,-4.638',
        translation: { x: 0, y: 0 },
        fillColor: 0x1d1d1b,
        borderColor: 0x1d1d1b,
        scale: 0.65
    }
]

export const TO_BUILD_PROJECTS_LOGO_SVG_PATHS: SvgPath[] = [
    {   // Compound
        path: 'M260.59,130.3c0,71.96-58.34,130.3-130.3,130.3S0,202.25,0,130.3,58.34,0,130.3,0s130.3,58.34,130.3,130.3ZM303.07,4.74h-13.67v250.26h13.67V4.74ZM1070.64,72.77v24.1h-33.05v91.34h-24.1v-91.34h-33.05v-24.1h90.2ZM665.49,108.91v43.31c0,51.12-94.43,51.28-94.43,0v-43.31c0-51.45,94.43-51.12,94.43,0ZM594.83,152.22c-.16,19.37,46.73,19.21,46.73,0v-43.31c.16-19.86-46.73-19.37-46.73,0v43.31ZM974.08,165.46c-14.75,37.43-92,33.14-92-13.24v-43.31c0-45.46,73.69-50.47,90.85-15.75l-22.45,9.08c-9.08-12.74-44.62-10.19-44.62,6.68v43.31c-.16,18.91,44.48,19.2,46.62,1.34l21.61,11.91ZM809.73,95.66v68.44h55.88v24.1h-80.58v-115.43h80.58v22.89h-55.88ZM863.21,141.09h-47.41v-23.62h47.41v23.62ZM1144.72,100.28c-5.09-7.98-11.2-11.88-23.08-11.88-10.69,0-16.47,4.92-16.47,12.9,0,9.16,7.47,13.24,23.09,17.15,24.44,6.11,35.47,15.27,35.47,35.98,0,19.18-12.9,34.12-40.4,34.12-20.54,0-34.8-5.6-45.15-19.18l18.16-12.56c6.28,7.81,13.41,11.71,25.46,11.71,13.58,0,18.16-5.94,18.16-13.07,0-8.15-4.92-12.73-23.94-17.65-23.08-6.11-34.63-17.14-34.63-36.49s12.22-32.93,40.06-32.93c18.67,0,32.76,6.28,41.07,19.18l-17.82,12.73ZM712.72,72.88h50.32v78.45c0,49.9-79.5,50.11-85.42-.63l21.57-4.86s5.71,19.24,22.62,19.24,17.34-14.17,17.34-14.17v-56.67h-26.43v-21.36ZM363.75,188.75v-116.3h46.94c21.14,0,40.6,12.48,40.6,39.33,0,28.97-25.37,40.17-40.6,40.17h-15.22v-22.2s3.38.21,11.63.21,20.72-4.44,20.72-18.18-15.22-15.22-21.36-15.22h-17.55v92.19h-25.16ZM511.03,96.56h-23.05v92.19h-25.16v-116.3h46.94c21.14,0,42.29,9.73,42.29,36.58,0,23.05-12.9,30.87-26.22,32.99l35.03,46.73h-31.29l-34.4-45.67v-19.66h14.17c6.98,0,17.55-3.17,17.55-14.59,0-7.82-6.98-12.26-15.86-12.26Z',
        translation: { x: 0, y: -10 },
        fillColor: 0x231f20,
        borderColor: 0x1d1d1b,
        scale: 0.17
    },
    {   // Compound
        path: 'M112.94,207.37h-32.32V52.93h32.32v154.44ZM125.2,160.01s72.35,10.76,72.35-52.8-72.35-54.28-72.35-54.28v32.12h16.18c12.33,0,24.59,8.65,24.59,22.93s-12.26,22.93-24.59,22.93h-16.18v29.1Z',
        translation: { x: 0, y: -10 },
        fillColor: 0xffffff,
        borderColor: 0x1d1d1b,
        scale: 0.17
    }
]

export const TO_BUILD_PROJECTS_PAYOFF_SVG_PATHS: SvgPath[] = [
    {   // Compound
        path: 'M260.59,130.3c0,71.96-58.34,130.3-130.3,130.3S0,202.25,0,130.3,58.34,0,130.3,0s130.3,58.34,130.3,130.3ZM303.07,4.74h-13.67v250.26h13.67V4.74ZM1070.64,72.77v24.1h-33.05v91.34h-24.1v-91.34h-33.05v-24.1h90.2ZM665.49,108.91v43.31c0,51.12-94.43,51.28-94.43,0v-43.31c0-51.45,94.43-51.12,94.43,0ZM594.83,152.22c-.16,19.37,46.73,19.21,46.73,0v-43.31c.16-19.86-46.73-19.37-46.73,0v43.31ZM974.08,165.46c-14.75,37.43-92,33.14-92-13.24v-43.31c0-45.46,73.69-50.47,90.85-15.75l-22.45,9.08c-9.08-12.74-44.62-10.19-44.62,6.68v43.31c-.16,18.91,44.48,19.2,46.62,1.34l21.61,11.91ZM809.73,95.66v68.44h55.88v24.1h-80.58v-115.43h80.58v22.89h-55.88ZM863.21,141.09h-47.41v-23.62h47.41v23.62ZM1144.72,100.28c-5.09-7.98-11.2-11.88-23.08-11.88-10.69,0-16.47,4.92-16.47,12.9,0,9.16,7.47,13.24,23.09,17.15,24.44,6.11,35.47,15.27,35.47,35.98,0,19.18-12.9,34.12-40.4,34.12-20.54,0-34.8-5.6-45.15-19.18l18.16-12.56c6.28,7.81,13.41,11.71,25.46,11.71,13.58,0,18.16-5.94,18.16-13.07,0-8.15-4.92-12.73-23.94-17.65-23.08-6.11-34.63-17.14-34.63-36.49s12.22-32.93,40.06-32.93c18.67,0,32.76,6.28,41.07,19.18l-17.82,12.73ZM712.72,72.88h50.32v78.45c0,49.9-79.5,50.11-85.42-.63l21.57-4.86s5.71,19.24,22.62,19.24,17.34-14.17,17.34-14.17v-56.67h-26.43v-21.36ZM363.75,188.75v-116.3h46.94c21.14,0,40.6,12.48,40.6,39.33,0,28.97-25.37,40.17-40.6,40.17h-15.22v-22.2s3.38.21,11.63.21,20.72-4.44,20.72-18.18-15.22-15.22-21.36-15.22h-17.55v92.19h-25.16ZM511.03,96.56h-23.05v92.19h-25.16v-116.3h46.94c21.14,0,42.29,9.73,42.29,36.58,0,23.05-12.9,30.87-26.22,32.99l35.03,46.73h-31.29l-34.4-45.67v-19.66h14.17c6.98,0,17.55-3.17,17.55-14.59,0-7.82-6.98-12.26-15.86-12.26Z',
        translation: { x: 0, y: -10 },
        fillColor: 0x231f20,
        borderColor: 0x1d1d1b,
        scale: 0.1
    },
    {   // Compound
        path: 'M112.94,207.37h-32.32V52.93h32.32v154.44ZM125.2,160.01s72.35,10.76,72.35-52.8-72.35-54.28-72.35-54.28v32.12h16.18c12.33,0,24.59,8.65,24.59,22.93s-12.26,22.93-24.59,22.93h-16.18v29.1Z',
        translation: { x: 0, y: -10 },
        fillColor: 0xffffff,
        borderColor: 0x1d1d1b,
        scale: 0.1
    }
]